import {call, put} from 'redux-saga/effects';
import {receiveTrainingVideosData} from "../actions/trainingVideosActions";
import {fetchTrainingVideosData} from "../api/fetchTrainingVideosData";

export default function* getTrainingVideosData(action) {
  try {
    const trainingVideosData = yield call(fetchTrainingVideosData);
    yield put(receiveTrainingVideosData(trainingVideosData));
  } catch (e) {
    console.log(e)
  }
}



// WEBPACK FOOTER //
// ./src/sagas/trainingVideosSaga.js